import Vue from 'vue'
import Vuex from 'vuex'
import header from "./modules/header-modules"
// import category_list from "./modules/category_list-modules"
// import details from "./modules/details-modules"
import user from "./modules/user-modules"
import cart from "./modules/cart-modules"
import commodity from "./modules/commodity-modules"
import order from "./modules/order-modules"

import createPersistedState from "vuex-persistedstate"
Vue.use(Vuex)


export default function createStore(){
  const plugins = []
  if (typeof window !== 'undefined') {
    plugins.push(
      createPersistedState({
        storage: window.sessionStorage,
      })
    )
  }
  return new Vuex.Store({
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    },
    modules: {
      header,
      user,
      cart,
      commodity,
      order
    },
    plugins:plugins
  })
  
}